import { render, staticRenderFns } from "./MemberStoriesSection.vue?vue&type=template&id=d9a7d4dc&scoped=true&"
import script from "./MemberStoriesSection.vue?vue&type=script&lang=ts&"
export * from "./MemberStoriesSection.vue?vue&type=script&lang=ts&"
import style0 from "./MemberStoriesSection.vue?vue&type=style&index=0&id=d9a7d4dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a7d4dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default,LinkButton: require('/opt/build/repo/apps/shop/components/storyblok/LinkButton/LinkButton.vue').default})
